import WatchListEntriesByWatchListPage from './WatchListEntriesByWatchListPage';

export default WatchListEntriesByWatchListPage;


// WEBPACK FOOTER //
// ./src/features/watch-list-entry/pages/watch-list-entries-by-watch-list-page/index.js